import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import { navigate } from 'gatsby';
import { Header as DlsHeader } from '@dls/web';
import RRPModal from '../RRPShoppingCart/RRPModal';

import IconShoppingCartLoggedIn from '../../assets/svgs/header/shop-logged-in.svg';
import IconShoppingCartDesktop from '../../assets/svgs/header/shop.svg';
import IconShoppingCartMobile from '../../assets/svgs/header/mobile-shop.svg';
import IconProfile from '../../assets/svgs/header/login.svg';
import IconProfileMobile from '../../assets/svgs/header/mobile-login.svg';
import IconHamburger from '../../assets/svgs/header/hamburger-line.svg';
import IconClose from '../../assets/svgs/header/close.svg';
import { navigation } from '../../middlewares/navigation-constants';

const Container = styled.div`
  position: relative;
`;

const RrpHeader = props => {
  const { data: header, baseUrl, isLoggedIn } = props;

  const rrpCartState = useSelector(state => state.rrpCart);
  const cartItemCount = rrpCartState?.rrpOrder?.ImplRRPOrderDetails.reduce(
    (acc, orderDetail) =>
      acc +
      orderDetail.orderItems.reduce(
        (orderItemQtyAcc, orderItem) => orderItemQtyAcc + orderItem.quantity,
        0
      ),
    0
  );

  const [showModal, setShowModal] = useState(false);
  const [navigationURL, setNavigationURL] = useState(null);

  const onMenuItemClick = (e, menuItem) => {
    if (
      menuItem.href.indexOf(
        '/personal/products-services/devices-and-gadgets'
      ) === -1
    ) {
      e.preventDefault();
      setNavigationURL(`${baseUrl}${menuItem.href}`);
      setShowModal(true);
    }
  };

  const handleModalCTAClick = () => {
    //clear cart handling
    // after clear cart handling navigate to the url
    navigate(navigationURL);
  };

  const rrpProps = {
    backgroundColor: '#FFFFFF',
    baseUrl: baseUrl,
    logo: {
      src: header.logo.href,
      alt: header.logo.alt,
      href: header.logo.link
    },
    menuIcons: [
      {
        icon: {
          desktop: IconProfile,
          mobile: IconProfileMobile,
          href: !isLoggedIn ? header.loginButtonUrl : null
        },
        subMenu: isLoggedIn ? header.avatarMenuItems : null
      },
      {
        icon: {
          desktop: isLoggedIn
            ? IconShoppingCartLoggedIn
            : IconShoppingCartDesktop,
          mobile: IconShoppingCartMobile,
          href: undefined,
          cartItemCount,
          onClick: () => navigate(`/${navigation.RRP_SHOPPING_CART}`)
        }
      }
    ],
    showHamburger: true,
    hamburgerOpenIcon: IconHamburger,
    hamburgerCloseIcon: IconClose,
    showLogoHamburger: true
  };

  return (
    <Container>
      {showModal && (
        <RRPModal
          header="You are leaving this page"
          visible={showModal}
          message="By proceeding, this will clear all the item(s) in your cart."
          onClose={() => setShowModal(false)}
          ctaText="Proceed"
          onButtonClick={() => handleModalCTAClick()}
          secondary
        />
      )}
      <DlsHeader
        {...rrpProps}
        firstLevelLinks={header.firstLevelLinks}
        menuItems={header.menuItems}
        onMenuItemClick={onMenuItemClick}
      />
    </Container>
  );
};

export default RrpHeader;
